import { render } from "./VitalsCharting.vue?vue&type=template&id=b40d8e48&scoped=true"
import script from "./VitalsCharting.vue?vue&type=script&lang=js"
export * from "./VitalsCharting.vue?vue&type=script&lang=js"

import "./VitalsCharting.vue?vue&type=style&index=0&id=b40d8e48&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40d8e48"]])

export default __exports__